import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { addressRoutes } from './routes';
export class Address {
  constructor() {
    _defineProperty(this, "routes", addressRoutes);
  }
  async validateAddress(data, options) {
    const resp = await requestService('paperCorrespondence').post(this.routes.validateAddress, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async addNewAddress(data, options) {
    const resp = await requestService('paperCorrespondence').post(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async updateAddress(data, options) {
    const resp = await requestService('paperCorrespondence').put(this.routes.baseUrl, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async batchGetAddresses(data, options) {
    const resp = await requestService('paperCorrespondence').post(this.routes.batchGetAddress, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async parseSingleLineAddress(data, options) {
    const resp = await requestService('paperCorrespondence').post(this.routes.parseAddress, data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}